module.exports = __webpack_public_path__ + "img/07-interoperability-standards.2a2cd11b.png";